<template>
  <div class="page_container brandIncreasePage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >商务&销售管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>合作&自有｜生产商管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 主要内容 start -->
    <div class="main_container">
      <div class="operation_wrap flex-between">
        <div class="select_add flex-rowl">
          <p class="flex-rowl" @click="handleGo()">
            <i class="iconfont icon-xinzeng"></i> 新增
          </p>
        </div>
        <div class="filter flex-rowr">
          <div class="search_wrap flex-between">
            <el-input
              v-model="params.keyword"
              placeholder="输入品牌关键字查找→"
              @keyup.enter.native="handleSearch()"
            ></el-input>
            <div class="search_btn flex-rowc" @click="handleSearch">
              <i class="iconfont icon-chazhaotubiao"></i>
            </div>
          </div>
        </div>
      </div>
      <div
        class="list_wrap"
        v-loading="loading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
      >
        <template v-if="dataList.length > 0">
          <div class="item_wrap" v-for="item in dataList" :key="item.id">
            <div class="item_main_wrap flex-between">
              <div class="content_wrap flex-between">
                <div class="intro_box flex-rowl">
                  <div class="block">
                    <p>
                      供应商名称：<span>{{ item.labelname }}</span>
                    </p>
                    <p>
                      供应商标签内容：<span>{{ item.labelcont }}</span>
                    </p>
                    <p>
                      状态：<span>{{
                        item.labelstate == 1 ? "启用" : "停用"
                      }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p>
                      所属企业：<span>{{ item.qyname }}</span>
                    </p>
                    <p>
                      添加日期：<span>{{ item.createdateNew }}</span>
                    </p>
                    <p>
                      操作人员：<span>{{ item.createman }}</span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="editBtn" @click="handleGo(item.id)">
                编辑供应商信息→
              </div>
            </div>
          </div>
        </template>
        <el-empty
          description="尚未添加合作品牌"
          v-if="!loading && dataList.length == 0"
        ></el-empty>
      </div>
    </div>
    <!-- 主要内容 end -->

    <!-- 分页 start -->
    <div class="pagination_wrap flex-rowc">
      <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next, jumper"
        :page-size="10"
        :total="listTotal"
      >
      </el-pagination>
    </div>
    <!-- 分页 end -->
  </div>
</template>
  
  <script>
import { getMenuAuthTwo, getSupplierList } from "../../api/api";
export default {
  name: "supplierList",
  data() {
    return {
      menuItem: "", // 权限菜单
      roleId: "", // 用户角色ID
      operationAuth: "", // 操作权限
      buttonAuth: "", // 按钮权限

      searchTxt: "",
      params: {
        qyid: 0,
        Page: 1,
        PageSize: 10,
        keyword: "",
      },
      loading: false,
      dataList: [],
      listTotal: 0,
    };
  },
  created() {
    let userInfo = this.$store.state.USERINFO;
    if (userInfo.qy) {
      this.params.qyid = userInfo.qy.id;
    } else {
      this.params.qyid = 0;
    }
    this.roleId = userInfo.qy.roleid;
    this.menuItem = this.$store.state.menuItem;
    this.getMenuAuthTwo();
    this.initData();
  },
  methods: {
    // 获取菜单栏权限
    getMenuAuthTwo() {
      let menuItem = this.$store.state.menuItem;
      getMenuAuthTwo(menuItem.parentid).then((res) => {
        res
          .filter((item) => {
            return item.id == menuItem.id;
          })
          .map((item) => {
            // 操作权限
            if (item.dorange) {
              this.operationList = item.dorange.split(",");
            }
          });
      });
    },

    handleSearch() {
      this.initData();
    },

    handleCurrentChange(e) {
      this.params.Page = e;
      // this.dataList = [];
      this.initData();
    },
    initData() {
      let { params } = this;
      this.loading = true;
      getSupplierList(params).then((res) => {
        res.forEach((v) => {
          if (v.createdate && v.createdate.indexOf("T") != -1) {
            let createdateSplit = v.createdate.split("T");
            v.createdateNew = createdateSplit[0] + " " + createdateSplit[1];
          }
        });
        // 按时间降序
        // dataNew.sort((a, b) => b.createdate.localeCompare(a.createdate))
        this.dataList = res;
        // 加载状态结束
        this.loading = false;
      });
    },
    handleReturn() {
      history.back();
    },
    handleGo(id) {
      let { roleId } = this;
      if (this.operationList.indexOf(roleId) == -1) {
        this.$message.warning("暂无权限");
        return;
      }

      if (id) {
        this.$router.push({
          path: "/supplierIndex/supplierDetail",
          query: { id },
        });
      } else {
        this.$router.push({ path: "/supplierIndex/supplierDetail" });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.brandIncreasePage {
  .list_wrap {
    .item_main_wrap {
      align-items: center;
    }
  }
}
</style>